import * as _ from 'lodash'
import { BRANDCHOSEN } from './config';

export const getVariations = (products, baseProduct) => {
    const { Nombre, Coleccion, Categoria, Color } = baseProduct;
    const list = products[BRANDCHOSEN] ? products[BRANDCHOSEN] : products;
  
    return list.reduce((acc, product) => {
      const isSame =
        product.Nombre.toLowerCase().trim() === Nombre.toLowerCase().trim() &&
        product.Coleccion.toLowerCase().trim() === Coleccion.toLowerCase().trim() &&
        product.Categoria.toLowerCase().trim() === Categoria.toLowerCase().trim() &&
        product.Color.toLowerCase().trim() === Color.toLowerCase().trim();
  
      if (isSame) {
        acc.push(product);
      }
      return acc;
    }, []);
  };
